<bl-modal-content
  #content
  [title]="data?.title || '顔認証'"
  [footerButtonType]="ModalButtonType.Custom"
>
  <div body
    class="face-detection"
  >
    <div class="face-detection__mode">
      <bl-radio-group
        [(value)]="_mode"
        [items]="FaceDetectionModalModeMap"
        [groupType]="InputGroupType.Switch"
        (changeEvent)="onChangeMode($event)"
      ></bl-radio-group>
    </div>
    <form
      novalidate
      class="face-detection__login"
      [class.hide]="_mode !== FaceDetectionModalMode.Regist"
      [formGroup]="_blFormGroup?.formGroup"
    >
      <div class="face-detection__login-id">
        <span class="title">ログインID</span>
        <bl-text-input #loginId
          class="item"
          [(value)]="_loginId"
          [placeholder]="'ログインIDを入力して下さい'"
          [option]="{ allows: ['number', 'alphabet', 'symbol'], convertHalf: true, denySpace: true }"
          [validator]="_blFormGroup?.validatorGroup['UserLoginInfo#accountID']"
          (changeEvent)="onChangeLoginId()"
        ></bl-text-input>
      </div>
      <div class="face-detection__login-id">
        <span class="title">パスワード</span>
        <bl-text-input #password
          class="item"
          [(value)]="_password"
          [placeholder]="'パスワードを入力して下さい'"
          [password]="true"
          [option]="{ allows: ['number', 'alphabet', 'symbol'], convertHalf: true, denySpace: true }"
          [validator]="_blFormGroup?.validatorGroup['UserLoginInfo#password']"
        ></bl-text-input>
      </div>
    </form>
    <div class="face-detection__camera">
      <bl-camera #camera
        [class.hidden]="_isShownCaptureImage"
        [isFaceDetection]="true"
        [showAuxiliaryLine]="data?.showAuxiliaryLine"
        [autoStartFaceDetection]="false"
        [camera]="_camera"
        (readyFaceDetectionEvent)="onReadyFaceDetection()"
        (detectionEvent)="onDoneFaceDetection($event)"
      ></bl-camera>
      <share-image-view
        [class.hidden]="!_isShownCaptureImage"
        [imageReference]="_imageViewRef"
        [pointerCursor]="false"
        [useFormStyle]="false"
        [scale]="{ x: -1 }"
      ></share-image-view>
      <div *ngIf="_mode === FaceDetectionModalMode.Regist"
        class="regist-operation__btn"
      >
        <ng-container *ngIf="_registState === FaceDetectionRegistState.Init; else registCaptureTemplate;">
          <button
            class="btn btn-success"
            type="button"
            [disabled]="!_isReadyFaceDetection || !_blFormGroup?.formGroup?.valid"
            (click)="onClickCaptuer()"
          >撮影</button>
        </ng-container>

        <ng-template #registCaptureTemplate>
          <button
            class="btn btn-default"
            type="button"
            [disabled]="_isPauseRegist || !_blFormGroup?.formGroup?.valid"
            (click)="onClickRetry()"
          >取り直し</button>
          <button #registButton
            class="btn btn-success"
            type="button"
            [disabled]="_isPauseRegist || !_blFormGroup?.formGroup?.valid"
            (click)="onClickRegist()"
          >登録</button>
        </ng-template>
      </div>
    </div>
  </div>
  <div footer class="content-footer">
    <button #closeButton type="button" class="btn btn-default" (click)="onClickClose()">閉じる</button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/face-detection-modal/face-detection-modal.component.html